import { render, staticRenderFns } from "./add_set.vue?vue&type=template&id=4c7f92ff&scoped=true&"
import script from "./add_set.vue?vue&type=script&lang=js&"
export * from "./add_set.vue?vue&type=script&lang=js&"
import style0 from "./add_set.vue?vue&type=style&index=0&id=4c7f92ff&prod&lang=scss&"
import style1 from "./add_set.vue?vue&type=style&index=1&id=4c7f92ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f92ff",
  null
  
)

export default component.exports